import React from "react";
import { useIntl } from "react-intl";
import { Wallet } from "@housebets/housebets-x-package";

import { IWalletPanelProps } from "../../types";

export const DepositsPanel: React.FC<IWalletPanelProps> = ({
    selectedCategory,
    cryptoData = [],
    fiatData = [],
    setSelectedCategory
}) => {
    const { $t } = useIntl();

    return (
        <>
            <Wallet.CategoryList
                title={$t({ id: "Crypto" })}
                activeItem={selectedCategory}
                data={cryptoData}
                onSelect={(value) => setSelectedCategory(value)}
            />
            <Wallet.CategoryList
                title={$t({ id: "Cash" })}
                activeItem={selectedCategory}
                data={fiatData}
                onSelect={(value) => setSelectedCategory(value)}
                pagination
                className="category-list"
            />
        </>
    );
};

DepositsPanel.displayName = "DepositsPanel";
